export const CLEAR_RERUN_TEST_HISTORY = "CLEAR_RERUN_TEST_HISTORY";
export const FETCH_ACTIVE_TUNNEL_LIST_FAILED =
  "FETCH_ACTIVE_TUNNEL_LIST_FAILED";
export const FETCH_ACTIVE_TUNNEL_LIST_LOADING =
  "FETCH_ACTIVE_TUNNEL_LIST_LOADING";
export const FETCH_ACTIVE_TUNNEL_LIST_SUCCESS =
  "FETCH_ACTIVE_TUNNEL_LIST_SUCCESS";
export const FETCH_SIMILAR_TEST_RETRY_LIST_FAILED =
  "FETCH_SIMILAR_TEST_RETRY_LIST_FAILED";
export const FETCH_SIMILAR_TEST_RETRY_LIST_LOADING =
  "FETCH_SIMILAR_TEST_RETRY_LIST_LOADING";
export const FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS =
  "FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS";
export const FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED =
  "FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED";
export const FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING =
  "FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING";
export const FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS =
  "FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS";
export const UPDATE_TEST_DETAILS_LOADING = "UPDATE_TEST_DETAILS_LOADING";
export const UPDATE_TEST_DETAILS_SUCCESS = "UPDATE_TEST_DETAILS_SUCCESS";
export const UPDATE_TEST_DETAILS_FAILED = "UPDATE_TEST_DETAILS_FAILED";
export const UPDATE_TEST_ATTEMPTS = "UPDATE_TEST_ATTEMPTS";
export const UPDATE_SELECTED_TEST_TO_RETRY = "UPDATE_SELECTED_TEST_TO_RETRY";
export const UPDATE_SELECTED_TEST_TO_REPRODUCE =
  "UPDATE_SELECTED_TEST_TO_REPRODUCE";
export const RESET_ACTIVE_TUNNEL_LIST = "RESET_ACTIVE_TUNNEL_LIST";
export const RESET_SIMILAR_TEST_LIST = "RESET_SIMILAR_TEST_LIST";
export const FETCH_TEST_RETRY_HISTORY_FAILED =
  "FETCH_TEST_RETRY_HISTORY_FAILED";
export const FETCH_TEST_RETRY_HISTORY_LOADING =
  "FETCH_TEST_RETRY_HISTORY_LOADING";
export const FETCH_TEST_RETRY_HISTORY_SUCCESS =
  "FETCH_TEST_RETRY_HISTORY_SUCCESS";
export const FETCH_TEST_REPRODUCE_HISTORY_FAILED =
  "FETCH_TEST_REPRODUCE_HISTORY_FAILED";
export const FETCH_TEST_REPRODUCE_HISTORY_LOADING =
  "FETCH_TEST_REPRODUCE_HISTORY_LOADING";
export const FETCH_TEST_REPRODUCE_HISTORY_SUCCESS =
  "FETCH_TEST_REPRODUCE_HISTORY_SUCCESS";
export const RERUN_TEST_LOADING = "RERUN_TEST_LOADING";
export const RERUN_TEST_SUCCESS = "RERUN_TEST_SUCCESS";
export const RERUN_TEST_FAILED = "RERUN_TEST_FAILED";
export const SET_RERUN_TYPE = "SET_RERUN_TYPE";
export const SET_IS_RERUN_PAGE = "SET_IS_RERUN_PAGE";
export const SET_IS_RERUN_EDIT_CAPABILITY_MODE =
  "SET_IS_RERUN_EDIT_CAPABILITY_MODE";
export const SET_IS_RERUN_ADVANCED_SETTINGS_MODE =
  "SET_IS_RERUN_ADVANCED_SETTINGS_MODE";
export const SET_RERUN_FULLSCREEN_MODE = "SET_RERUN_FULLSCREEN_MODE";
export const SET_RERUN_TEST_DETAILS = "SET_RERUN_TEST_DETAILS";
export const CLEAR_RERUN_TEST_DETAILS = "CLEAR_RERUN_TEST_DETAILS";
export const LAMBDATEST_PARENT_TEST_DETAIL_LOADING =
  "LAMBDATEST_PARENT_TEST_DETAIL_LOADING";
export const LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS =
  "LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS";
export const LAMBDATEST_PARENT_TEST_DETAIL_FAILED =
  "LAMBDATEST_PARENT_TEST_DETAIL_FAILED";
export const STOP_REPLAY_TEST_LOADING = "STOP_REPLAY_TEST_LOADING";
export const STOP_REPLAY_TEST_SUCCESS = "STOP_REPLAY_TEST_SUCCESS";
export const STOP_REPLAY_TEST_FAILED = "STOP_REPLAY_TEST_FAILED";
export const PAUSE_REPLAY_TEST_FAILED = "PAUSE_REPLAY_TEST_FAILED";
export const PAUSE_REPLAY_TEST_LOADING = "PAUSE_REPLAY_TEST_LOADING";
export const PAUSE_REPLAY_TEST_SUCCESS = "PAUSE_REPLAY_TEST_SUCCESS";
export const RESUME_REPLAY_TEST_FAILED = "RESUME_REPLAY_TEST_FAILED";
export const RESUME_REPLAY_TEST_LOADING = "RESUME_REPLAY_TEST_LOADING";
export const RESUME_REPLAY_TEST_SUCCESS = "RESUME_REPLAY_TEST_SUCCESS";
export const STEPOVER_REPLAY_TEST_FAILED = "STEPOVER_REPLAY_TEST_FAILED";
export const STEPOVER_REPLAY_TEST_LOADING = "STEPOVER_REPLAY_TEST_LOADING";
export const STEPOVER_REPLAY_TEST_SUCCESS = "STEPOVER_REPLAY_TEST_SUCCESS";
export const DEBUGGER_STATE_LOADING = "DEBUGGER_STATE_LOADING";
export const DEBUGGER_STATE_SUCCESS = "DEBUGGER_STATE_SUCCESS";
export const DEBUGGER_STATE_FAILED = "DEBUGGER_STATE_FAILED";
export const MODIFY_BREAKPOINT_SUCCESS = "MODIFY_BREAKPOINT_SUCCESS";
export const MODIFY_BREAKPOINT_FAILED = "MODIFY_BREAKPOINT_FAILED";
export const MODIFY_BREAKPOINT_LOADING = "MODIFY_BREAKPOINT_LOADING";
export const FETCH_ALL_BREAKPOINTS_SUCCESS = "FETCH_ALL_BREAKPOINTS_SUCCESS";
export const FETCH_ALL_BREAKPOINTS_FAILED = "FETCH_ALL_BREAKPOINTS_FAILED";
export const FETCH_ALL_BREAKPOINTS_LOADING = "FETCH_ALL_BREAKPOINTS_LOADING";
export const UPDATE_PLAYBACK_SPEED_FAILED = "UPDATE_PLAYBACK_SPEED_FAILED";
export const UPDATE_PLAYBACK_SPEED_LOADING = "UPDATE_PLAYBACK_SPEED_LOADING";
export const UPDATE_PLAYBACK_SPEED_SUCCESS = "UPDATE_PLAYBACK_SPEED_SUCCESS";
export const UPDATE_DEBUGGER_STATE = "UPDATE_DEBUGGER_STATE";
export const UPDATE_COMMAND_BREAKPOINT = "UPDATE_COMMAND_BREAKPOINT";
export const UPDATE_UNSAVED_CAPABILITY = "UPDATE_UNSAVED_CAPABILITY";
